import React from 'react';
import Grid from '@material-ui/core/Grid';
import UserGroupsTable from './Components/UserGroupsTable';


export default function UserGroups() {

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
                <UserGroupsTable />
            </Grid>
        </Grid>
    );
}